export default __webpack_public_path__ + "static/media/fastpizza.551c3c5d.svg";